import styled from 'styled-components';
import { titleMedium, titleSmall } from 'styles-js/mixins/typography';

export const Body = styled.div.attrs<{ 'data-testid'?: string }>({ 'data-testid': 'modal-body' })`
  padding: 30px 40px;
  overflow-y: auto;
  height: 600px;
  justify-content: center;
  display: flex;
  flex-direction: column;
  @media (${({ theme }) => theme.underScreenXsmall}) {
    height: 100vh;
    padding: 20px;
  }
  h3 {
    ${titleMedium}
  }
  h4 {
    ${titleSmall}
  }
  ul {
    padding: 0 1em;
    li {
      margin-bottom: 5px;
    }
  }
  p {
    margin-bottom: 10px;
  }
`;

export const Footer = styled.footer<{ isMultiButton?: boolean }>`
  padding: 15px 40px;
  background-color: ${({ theme }) => theme.colorBlueBackground};
  display: flex;
  justify-content: ${({ isMultiButton }) => isMultiButton ? 'space-between' : 'flex-end'};
  @media (${({ theme }) => theme.underScreenXsmall}) {
    padding: 10px 20px;
  }
  button {
    margin: 0;
  }
`;
